export enum SingleCanvasDimensions {
  Width = 400,
  Height = 400,
}

export enum SingleCanvasDimensionsMobile {
  Width = 300,
  Height = 300,
}
